import React, { useState } from 'react';
import Navbar from '../Components/Navbar';
import PageHeader from '../Components/PageHeader';
import Footer from '../Components/Footer';
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs.send(
      "service_ght7hfk",
      "template_fji6d16",
      {
        user_name: formData.name,
        user_email: formData.email,
        phone: formData.phone,
        company: formData.company,
        service: formData.service,
        message: formData.message,
      },
      "-XPJBf2qj-HMAxcv0"
    )
    .then(() => {
      alert('Thank you for your message! We will get back to you soon.');
      
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      });

      setIsSubmitting(false);
    })
    .catch((error) => {
      console.log(error);
      alert("Failed to send message");
      setIsSubmitting(false);
    });
  };

  const services = [
    'Cybersecurity',
    'Cloud Services',
    'Web Development',
    'SEO & Digital Marketing',
    'Mobile Apps & Software',
    'Hosting & Domains',
    'Other'
  ];

  return (
    <div>
      <Navbar />
      <PageHeader 
        title="Contact Us" 
        subtitle="Get in touch with our team to discuss your project requirements and get a free consultation." 
      />
      
      {/* Contact Form & Info */}
      <section className="py-16 px-6 bg-netbernet-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl md:text-3xl font-bold text-netbernet-black mb-6">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="Your full name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="+91 12345 67890"
                    />
                  </div>
                  <div>
                    <label htmlFor="company" className="block text-gray-700 font-medium mb-2">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="Your company"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="service" className="block text-gray-700 font-medium mb-2">Service Required</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                  >
                    <option value="">Select a service</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors resize-vertical"
                    placeholder="Tell us about your project requirements..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-netbernet-blue text-netbernet-white px-6 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              <div className="bg-netbernet-blue p-8 rounded-xl text-netbernet-white">
                <h2 className="text-2xl md:text-3xl font-bold mb-6">Get in Touch</h2>
                <p className="text-lg mb-8 opacity-90">
                  Ready to take your business to the next level? Contact us today and let's discuss how we can help you achieve your goals.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <svg className="w-6 h-6 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <h3 className="font-semibold">Office Address</h3>
                      <p className="opacity-90">Ring Road, Pillar No. 102, Attapur<br />Hyderabad, Telangana 500006, India</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <svg className="w-6 h-6 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div>
                      <h3 className="font-semibold">Phone Numbers</h3>
                      <p className="opacity-90">+91 630 131 5362<br />+91 40 45126535</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <svg className="w-6 h-6 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <div>
                      <h3 className="font-semibold">Email Addresses</h3>
                      <p className="opacity-90">info@netbernet.com</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <svg className="w-6 h-6 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <h3 className="font-semibold">Business Hours</h3>
                      <p className="opacity-90">Monday - Saturday: 10:00 AM - 7:00 PM<br />Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Response */}
              <div className="bg-gray-50 p-6 rounded-xl">
                <h3 className="text-lg font-semibold mb-4 text-netbernet-black">Quick Response Time</h3>
                <p className="text-gray-600 mb-4">
                  We typically respond to all inquiries within 2-4 business hours. For urgent matters, please call us directly.
                </p>
                <div className="flex space-x-4">
                  <span className="bg-netbernet-blue text-netbernet-white px-3 py-1 rounded-full text-sm">Free Consultation</span>
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm">24/7 Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 px-6 bg-gray-100">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-stretch">
            {/* Left: Heading + Map */}
            <div className="w-full md:w-1/2 flex flex-col">
              <div className="mb-6">
                <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-2">Find Us</h2>
                <p className="text-xl text-gray-600">Visit our office in Hyderabad</p>
              </div>

              <div className="bg-netbernet-white rounded-xl overflow-hidden shadow-lg flex-1">
                <div className="w-full h-[400px]">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d951.9392923161317!2d78.42994392842617!3d17.37541399896507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDIyJzMxLjUiTiA3OMKwMjUnNTAuMSJF!5e0!3m2!1sen!2sin!4v1776433381084!5m2!1sen!2sin"
                    className="w-full h-full"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2 flex flex-col pl-14">
              <div className="mt-[72px] h-[400px]">
                <iframe src="https://lottie.host/embed/aab18315-8adf-48f4-9edb-78f26f21155f/hGxyuuQluJ.lottie"
                className="w-full h-full"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  ></iframe>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;